import {CommandBase} from "./commandBase";
import {BuildingReward, RemoteConstantsModel} from "../models/remoteConstants.model";

// Mutator-style edit for a single BuildingReward. Matches the pattern of
// ChangeMetadataCommand — caller passes a callback that takes the live record
// and mutates it. One command covers every per-reward field change.
export class UpdateBuildingPassiveRewardCommand extends CommandBase {
    buildingId: string;
    rewardUid: string;
    change: (reward: BuildingReward) => void;

    constructor(buildingId: string, rewardUid: string, change: (reward: BuildingReward) => void) {
        super();
        this.buildingId = buildingId;
        this.rewardUid = rewardUid;
        this.change = change;
    }

    execute(data: RemoteConstantsModel): boolean {
        const building = data.buildings.find(b => b.id === this.buildingId);
        if (!building) return false;
        const reward = building.passiveRewards?.find(r => r.uid === this.rewardUid);
        if (!reward) return false;
        this.change(reward);
        return true;
    }
}
